var _line, _circle, _line2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgHeroBgLines(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1035,
    height: 276,
    viewBox: "0 0 1035 276",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 1073,
    y1: 215.45,
    x2: -7,
    y2: 215.45,
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.899746
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 83.4064,
    cy: 83.4064,
    r: 82.9565,
    transform: "matrix(-1 0 0 1 1072.81 154)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.899746
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    y1: -0.449873,
    x2: 328.418,
    y2: -0.449873,
    transform: "matrix(0 -1 -1 0 968.094 299.419)",
    stroke: "white",
    strokeOpacity: 0.5,
    strokeWidth: 0.899746
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroBgLines);
export default __webpack_public_path__ + "static/media/heroBgLines.f674800cfcf73394d7c6451c52720d58.svg";
export { ForwardRef as ReactComponent };